var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4383 11.0499L11.2483 20.2399C10.1225 21.3658 8.59552 21.9983 7.00334 21.9983C5.41115 21.9983 3.88418 21.3658 2.75834 20.2399C1.63249 19.1141 1 17.5871 1 15.9949C1 14.4027 1.63249 12.8758 2.75834 11.7499L11.9483 2.55992C12.6989 1.80936 13.7169 1.3877 14.7783 1.3877C15.8398 1.3877 16.8578 1.80936 17.6083 2.55992C18.3589 3.31048 18.7806 4.32846 18.7806 5.38992C18.7806 6.45138 18.3589 7.46936 17.6083 8.21992L8.40834 17.4099C8.03306 17.7852 7.52406 17.996 6.99334 17.996C6.46261 17.996 5.95362 17.7852 5.57834 17.4099C5.20306 17.0346 4.99222 16.5256 4.99222 15.9949C4.99222 15.4642 5.20306 14.9552 5.57834 14.5799L14.0683 6.09992",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesIcon);
export default __webpack_public_path__ + "static/media/FilesIcon.cb4519db25a2116478419111c1851851.svg";
export { ForwardRef as ReactComponent };